var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPizza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_1329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.46 46.09C46.53 45.67 46.56 45.22 46.56 44.75C46.56 40.46 43.58 37.48 39.29 37.48C35 37.48 32.02 40.46 32.02 44.75C32.02 47.85 33.58 50.27 36.06 51.36",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.86 23.35C22.45 24.4 24.76 27.51 24.76 31.67C24.76 36.83 21.2 40.39 16.04 40.39C14.13 40.39 12.45 39.91 11.1 39.04",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.94 13.14C42.62 15.04 51.55 23.98 53.46 36.66C53.9 39.6 56.36 41.8 59.33 41.76C62.78 41.71 65.5 38.69 65.05 35.27C62.63 16.88 49.72 3.97 31.33 1.55C27.91 1.1 24.89 3.83 24.84 7.27C24.8 10.24 27 12.7 29.94 13.14Z",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.12 11.31C25.12 11.31 -1.62 61.37 1.8 64.8C5.23 68.23 55.28 41.49 55.28 41.49",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.57 22.94L34.94 24.4",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.04 50.56L18.95 49.11",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_1329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.6,
    height: 66.6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizza);
export default __webpack_public_path__ + "static/media/pizza.8bc256b30337ef3f9b7d5890f4ce6747.svg";
export { ForwardRef as ReactComponent };